import { render, staticRenderFns } from "./feeTemplateDetail.vue?vue&type=template&id=8f4676f8&scoped=true&"
import script from "./feeTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./feeTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./feeTemplateDetail.vue?vue&type=style&index=0&id=8f4676f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4676f8",
  null
  
)

export default component.exports